export default "__VITE_ASSET__DqJi3wvV__"